module.exports = __webpack_public_path__ + "img/2-4-who-food.b1a75ad3.jpg";